function isNativeApp() {
  return document.documentElement.hasAttribute('data-turbo-native-app');
}

function sendBridgeMessage(eventName, data = {}) {
  if (!isNativeApp()) return;

  // Android - use Hotwire Native bridge
  if (window.HotwireNative?.web) {
    window.HotwireNative.web.send({
      component: "nativeApp",
      event: eventName,
      data: {
        ...data,
        metadata: { url: window.location.href }
      }
    });
  }
  // iOS - use WebKit message handlers
  if (window.webkit?.messageHandlers?.nativeApp) {
    window.webkit.messageHandlers.nativeApp.postMessage({ name: eventName, ...data });
  }
}

function setupNativeHaptic() {
  if (!isNativeApp()) return;

  document.querySelectorAll('.trigger-native-haptic:not([data-haptic-initialized])').forEach(element => {
    element.addEventListener('click', () => {
      triggerHaptic();
    });
    element.setAttribute('data-haptic-initialized', 'true');
  });

  document.querySelectorAll('.trigger-native-haptic-light:not([data-haptic-initialized])').forEach(element => {
    element.addEventListener('click', () => {
      triggerHaptic("light");
    });
    element.setAttribute('data-haptic-initialized', 'true');
  });
}

export function triggerHaptic(level = "medium") {
  if (!isNativeApp()) return;
  if (level === "light") {
    sendBridgeMessage("trigger_haptic_light");
  } else {
    sendBridgeMessage("trigger_haptic");
  }
}

// Clear init attributes before Turbo caches the page
// so event listeners get re-added when restoring from cache
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll('[data-haptic-initialized]').forEach(element => {
    element.removeAttribute('data-haptic-initialized');
  });
});

document.addEventListener("turbo:load", setupNativeHaptic);
document.addEventListener('turbo:frame-load', setupNativeHaptic);

window.triggerHaptic = triggerHaptic;
